import { ParsedUrlQuery } from "querystring";
import _ from "lodash";
import { IBaseTag } from "../redux/types/tags";

export function getTypesUrl(
  all: number[],
  baseTags: IBaseTag[]
): { newPathname: string, newQuery: ParsedUrlQuery } {

  const newMapTypes = _(baseTags).filter((value) => _.includes(all, value._id)).map('sysName').value();
  const newPathname = `/map`;
  const newQuery = { ...newMapTypes.length && { type: newMapTypes.join(',') } }
  return {
    newPathname: newPathname || '',
    newQuery: newQuery
  }
}
